<template>
  <div>
    <vsmallheader></vsmallheader>
    <div style="width: 1200px;margin: 0 auto;padding:20px 0;font-size:14px;display: flex;">
      <div style="font-size:14px;color:#888;display:flex;align-items: center">
        <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
        当前位置：
      </div>
      <span style="cursor: pointer;font-size: 14px;" @click="retrun">电子证书</span>
      /证书详情
    </div>
    <div class="peoplecermessage">
      <div>
        <div>
          姓名：
          <span>{{cerdata.uid}}</span>
        </div>
        <div>
          培训名称：
          <span>{{cerdata.name}}</span>
        </div>
        <div>
          发证单位：
          <span>{{cerdata.actUnitZB}}</span>
        </div>
      </div>
      <div>
        <div>
          证书编号：
          <span>{{cerdata.code}}</span>
        </div>
        <div>
          发证时间：
          <span>{{cerdata.publishTime}}</span>
        </div>
        <div></div>
      </div>
      <div>
        <div>
          <!-- <el-button type="primary" v-print="'#print_content'">证书打印</el-button> -->
          <el-button type="primary" @click="downPdfFile">下载PDF</el-button>
        </div>
        <!-- <div class="delbg-box">
          <img
            class="delbg"
            v-show="delbg==true"
            src="@/assets/images/u109_disabled.svg"
            @click="btnDelBg"
          />
          <img
            class="delbg"
            v-show="delbg==false"
            src="@/assets/images/u109_selected.svg"
            @click="btnDelBg"
          />

          <span class="delbg-text">去除证书背景</span>
        </div> -->
      </div>
    </div>
    <div class="certifi">
      <div
        id="print_content"
        class="drawingboard"
        :style="'width:'+cerdata.modelWidth+'px;height:'+cerdata.modelHeight+'px;background-image: url('+imgbgc+');'"
        style="overflow:hidden"
      >
        <div v-for="(item) in dragResizes" :key="item.label">
          <!-- :style="'width:'+item.options.width+'px;height:'+item.options.height+'px'" -->
          <img
            v-if="item.type=='image'"
            slot="reference"
            class="image"
            :alt="item.name"
            :style="'position: absolute;width:'+item.options.width+'px;height:'+item.options.height+'px;top:'+item.y+'px;left:'+item.x+'px'"
            :src="item.url"
            @mousedown.self.prevent="null"
          />
          <div
            v-if="item.type=='text'"
            slot="reference"
            class="text"
            :style="'position: absolute;top:'+item.y+'px;left:'+item.x+'px;width:'+item.options.width+'px;height:'+item.options.height+'px;font-size: '+item.textStyle.fontSize+'; color: '+item.textStyle.color+'; font-family: '+item.textStyle.fontFamily+'; font-weight: '+item.textStyle.fontWeight+'; text-decoration: '+item.textStyle.textDecoration+'; line-height: '+item.textStyle.lineHeight+'; text-indent: '+item.textStyle.textIndent+'; letter-spacing: '+item.textStyle.letterSpacing+';'"
            v-html="item.htmlContent"
          ></div>
        </div>
      </div>
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>
<script>
import * as certificate from '@/api/certificate/index';
import vsmallheader from '@/views/smallHeader/index';
import linecom from '@/components/linecom/index';
import axios from 'axios';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
export default {
  components: {
    vsmallheader,
    linecom,
  },
  data() {
    return {
      delbg: true,
      dragResizes: [],
      cerdata: [],
      imgbgc: '',
    };
  },
  created() {
    // console.log(this.$route.query.code)
    this.GetCerDataDetail();
  },

  methods: {
    btnDelBg() {
      this.delbg = !this.delbg;

      if (!this.delbg) {
        this.imgbgc = '';
      } else {
        this.imgbgc = this.cerdata.backGround;
      }
    },
    DownCerPDF() {
      let data = {
        cdid: this.cerdata.cdid,
      };
      if (this.delbg) {
        data.bg = 1;
      } else {
        data.bg = 0;
      }
      certificate.DownCerPDF(data).then((res) => {
        console.log(res);
        this.saveFileToBlob(res.result);
      });
    },
    // 下载pdf(已废弃)
    saveFileToBlob(blobs) {
      window
        .fetch(blobs)
        .then(function (response) {
          if (response.ok) {
            return response.arrayBuffer();
          }
          throw new Error('Network response was not ok.');
        })
        .then(function (arraybuffer) {
          let blob = new Blob([arraybuffer], {
            type: `application/pdf;charset-UTF-8`, //word文档为msword,pdf文档为pdf
          });

          let objectURL = URL.createObjectURL(blob);

          let downEle = document.createElement('a');
          let fname = `证书`; //下载文件的名字
          downEle.href = objectURL;
          downEle.setAttribute('download', fname);
          document.body.appendChild(downEle);
          downEle.click();
        })
        .catch(function (error) {
          console.log(
            'There has been a problem with your fetch operation: ',
            error.message
          );
        });
    },
    //下载Pdf文件
    downPdfFile(){
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      let imageWrapper = document.querySelector('#print_content');
      var title = this.cerdata.uid + ` (${this.cerdata.name})`;
      html2Canvas(imageWrapper, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        // taintTest: false,
        imageTimeout: 0,
        height: imageWrapper.offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
        width: imageWrapper.offsetWidth,
        // x: 400,
        // y: 320,
        x: imageWrapper.offsetLeft,
        y: imageWrapper.offsetTop,
        dpi: window.devicePixelRatio * 4, // 解决图片不清晰问题
      }).then(function (canvas) {
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;

        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;

        let pageData = canvas.toDataURL('image/jpeg', 1);
        // 第一个参数： l：横向  p：纵向
        // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
        // 第三个参数：可以是下面格式，默认为“a4” 'l', 'px', [imgWidth, imgHeight]

        // console.log(pageData)
        let PDF;
        if (imgWidth > imgHeight) {
          PDF = new JsPDF('l', 'px', [imgWidth, imgHeight]);
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
          PDF = new JsPDF('p', 'px', [418.76, 595.28]);
          PDF.addImage(pageData, 'JPEG', 0, 0, 418.76, 595.28);
        }
        PDF.save(title + '.pdf');
        loading.close();
      });
    },

    retrun() {
      this.$router.go(-1);
    },
    // 获取单个证书数据
    GetCerDataDetail() {
      let para = {
        code: this.$route.query.code,
      };
      certificate.GetCerDataDetail(para).then((res) => {
        // console.log(res);
        this.cerdata = res.result[0];
        this.imgbgc = this.cerdata.backGround;
        this.dragResizes = JSON.parse(this.cerdata.variable);
        // console.log(this.dragResizes);
      });
    },
  },
};
</script>
<style scoped>
.peoplecermessage {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
  height: 108px;
  /* margin-top: 20px; */
  display: flex;
  padding: 20px;
  font-size: 16px;
  color: #7f7f7f;
  font-weight: 700;
  border-radius: 7px;
}
.peoplecermessage > div:nth-child(1) {
  flex: 2;
}
.peoplecermessage > div:nth-child(1) > div,
.peoplecermessage > div:nth-child(2) > div {
  height: 36px;
  line-height: 36px;
}
.peoplecermessage > div:nth-child(1) > div > span,
.peoplecermessage > div:nth-child(2) > div > span {
  font-weight: 400;
}
.peoplecermessage > div:nth-child(2) {
  flex: 2;
}
.peoplecermessage > div:nth-child(3) {
  flex: 1;
}
.certifi {
  margin-top: 20px;
  padding-bottom: 20px;
  min-height: 500px;
}
.delbg-box {
  display: flex;
  margin-right: 15px;
  margin-top: 20px;
}
.delbg {
  padding-right: 5px;
}
.printing,
.download {
  width: 152px;
  height: 48px;
  line-height: 48px;
  background-color: #dd4d4c;
  border-radius: 20px;
  text-align: center;
  color: white;
  margin-right: 15px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
}
.printing,
.download:hover {
  background-color: #cc3635;
}
.print {
  color: red;
}
.info-title {
  font-weight: 700;
}
.print:hover {
  color: rgb(13, 92, 196);
  cursor: pointer;
}
.drawingboard {
  position: relative;
  margin: 0 auto;
  /* margin-top: 20px; */
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}
</style>